import { render, staticRenderFns } from "./Claude.vue?vue&type=template&id=cb01ae90&scoped=true&"
import script from "./Claude.vue?vue&type=script&lang=js&"
export * from "./Claude.vue?vue&type=script&lang=js&"
import style0 from "./Claude.vue?vue&type=style&index=0&id=cb01ae90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb01ae90",
  null
  
)

export default component.exports